<div class="row mt-3 p-2">
    <div class="col bg-white rounded shadow-sm border border-black pt-2">
        <span>Escolha os usuários com acesso a esse grupo:</span>
        <div class="mt-2">
            <input class="input form-control form-control-sm" [(ngModel)]="filtrar" type="text"
                placeholder="Pesquise pelo nome do usuário" (ngModelChange)="filtrarUsuario()">
        </div>
        <table class="table">
            <thead>
                <tr>
                    <th>id</th>
                    <th>nome</th>
                    <th>email</th>
                </tr>
            </thead>
            <tbody>
                <tr class="hover"
                    *ngFor="let usuario of usuariosTabela | paginate: {itemsPerPage: 5, currentPage: paginaAtual}"
                    (click)="selecionarusuario(usuario)">
                    <td>{{usuario.sr_id}}</td>
                    <td>{{usuario.vc_nome}}</td>
                    <td>{{usuario.vc_login}}</td>
                </tr>
            </tbody>
        </table>
        <pagination-controls class="pagination d-flex flex-row-reverse" (pageChange)="paginaAtual = $event"
            previousLabel="Anterior" nextLabel="Próximo"></pagination-controls>
    </div>
</div>
<div class="row">
    <div class="col">
        <h3>Usuários selecionados</h3>
        <ul style="max-height: 22vh; overflow: auto;">
            <li class="hover" *ngFor="let usuario of usuariosSelecionado; let i = index" (click)="removerUsuario(i)">
                {{usuario.vc_nome}}<mat-icon class="material-icons-sharp del">
                    delete_forever
                </mat-icon>
            </li>
        </ul>
    </div>
</div>
<div class="mt-auto p-2 bd-highlight d-flex flex-row justify-content-between row">
    <button (click)="cancel()" class="btn-cancelar btn btn-lg btn-danger" type="btn">Cancelar</button>
    <button class="btn-sucesso btn btn-lg btn-success" (click)="enviarUsuariosSelecionados()"
        [disabled]="!usuariosSelecionado.length">Confirmar</button>
</div>